import { ThunkAction } from 'redux-thunk';
import { State as LoginState } from '@telstra-connect/login';
import {
    getPaymentTokenInitiated,
    getPaymentTokenSuccess,
    getPaymentTokenError
} from '../actions/get-payment-token';
import {IPaymentTokenData} from '../state/get-payment-token';
import { Http, DefaultCompany } from '@telstra-connect/utils';
export function getPaymentToken(accountId: string, cidn: string):
ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch, getState) => {
        const { user: userState } = getState();
        const defaultCompanyId = DefaultCompany.getDefaultCompanyId(userState);
        const appendHeader =  Http.get<IPaymentTokenData>({
            url: `/billing/v5/account/${accountId}/getBraintreePaymentToken`,
            customHeaders: {
                'company-id': cidn || defaultCompanyId
            },
            state: getState()
        });
        dispatch(getPaymentTokenInitiated());
        return appendHeader.then((result) =>
            dispatch(getPaymentTokenSuccess(result))).catch((error) => dispatch(getPaymentTokenError('Error')));
    };
}
